<div *ngIf="isloader" class="h-100 w-100 padt-5">
    <mat-progress-bar [mode]="'indeterminate'">
    </mat-progress-bar>
</div>
<div class="d-flex flex-column" *ngIf="!isloader && !isError">
    <div class="vehicle-profile-header">{{widgetData?.title}} <span>&nbsp;<img alt="Info" matTooltipClass="new-lines" matTooltip="Healthy>35 min &#13;
                Critical<30 min &#13;
                Critical time=30 min, Critical temperature=40°C" class="h-20px"
                src="../../../../assets/images/info-icon.svg">
            <!-- <img alt="Info" matTooltip="Time to hit critical temperature is greater than critical time" class="h-20px"
                *ngIf="assetHealthData?.currentEntityStatus?.status === 'unsafe'"
                src="../../../../assets/images/info-icon.svg"> -->
        </span></div>
    <div class="d-grid g-gap20 h-100 p-3">
        <div class="d-flex justify-content-center py-1 border-bottom">
            <div class="d-flex align-items-center justify-content-center flex-column flex1">
                <h1>Current Status</h1>
                <div *ngIf="false">For assets</div>
            </div>
            <div class="flex1 p-4 d-flex justify-content-center">
                <div class="vehicle-values w-100 vehicle-score-value p-20"
                    [ngClass]="{'border-nodata': !assetHealthData?.currentEntityStatus?.colour}"
                    [style.color]="assetHealthData?.currentEntityStatus?.colour">
                    <span
                        *ngIf="assetHealthData?.currentEntityStatus?.status">{{assetHealthData?.currentEntityStatus?.status
                        | titlecase}}</span>
                    <span *ngIf="!assetHealthData?.currentEntityStatus?.status">NA</span>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center py-1">
            <div class="d-flex align-items-center justify-content-center flex-column flex1 border-right">
                <div class="mb-1 pbottom-5">Time to hit critical temperature</div>
                <div class="vehicle-score-value line-height">
                    <span
                        *ngIf="assetHealthData?.criticalTemperatureHitTime">{{assetHealthData?.criticalTemperatureHitTime}}</span>
                    <span *ngIf="!assetHealthData?.criticalTemperatureHitTime">NA</span>
                </div>
            </div>
            <div class="d-flex align-items-center justify-content-center flex-column flex1 ">
                <div class="mb-1 pbottom-5">Rate of Change</div>
                <div class="vehicle-score-value ">
                    <span *ngIf="assetHealthData?.criticalTemperatureHitTime">{{assetHealthData?.rateChange}}</span>
                    <span *ngIf="!assetHealthData?.criticalTemperatureHitTime">NA</span>
                </div>
            </div>
        </div>
    </div>
</div>
<p *ngIf="isloader || isError">No Data Available</p>